import type { ContentfulClientApi } from "contentful";
import type { ProductInfoEntry } from "../types";

export type GetProductInfoByAdGroupOptions = {
    adGroups: string[];
    limit?: number;
    skip?: number;
};

export async function getProductInfoByAdGroup(
    client: ContentfulClientApi<undefined>,
    { adGroups, skip = 0, limit = 50 }: GetProductInfoByAdGroupOptions,
) {
    return await client.withoutUnresolvableLinks.getEntries<ProductInfoEntry>({
        content_type: "productInfo",
        limit,
        skip,
        order: ["sys.createdAt"],
        include: 10,
        "fields.adGroup[in]": adGroups,
    });
}
